import { DocumentType } from '@/lib/patientDocumentsApi';
import { StatusChip } from '@/components/ui/status-chip';

export const TYPE_META: Record<DocumentType, { label: string }> = {
  external_prescription: { label: 'External Rx' },
  clinical_photo: { label: 'Clinical photo' },
  identity_document: { label: 'ID / Insurance' },
  other: { label: 'Other' },
};

/** The document's type as a neutral chip — it is a label, not a status, so it carries no colour. */
export default function TypeBadge({ type }: { type: DocumentType }) {
  return <StatusChip tone="neutral" className="flex-shrink-0">{TYPE_META[type].label}</StatusChip>;
}
